export const swapiUrl = process.env.REACT_APP_SWAPI_URL;
